import React, { FC } from 'react';
import { SafeHtml, useScopedSelector } from 'ia-react-core';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import { getContentFieldValue } from './getContentFieldValue';
import { StyledNeedHelpButton, StyledNeedHelpModal, StyledBusinessHours, StyledPhoneNumber } from './NeedHelp.styles';
import { Content } from './interfaces/Content';

export interface NeedHelpProps {
  hasOnClose?: Boolean;
  testSmallScreen?: Boolean;
}

const NeedHelp: FC<NeedHelpProps> = ({ hasOnClose, testSmallScreen }) => {
  const content: Content = useScopedSelector('content');
  const { t } = useTranslation('NeedHelp');
  const isSmallScreen = useMediaQuery({ query: '(max-width: 600px)' });

  if (!content?.isLoaded) return null;

  const description = getContentFieldValue(content.needHelp, 'Description');
  const title = getContentFieldValue(content.needHelp, 'Title');
  const businessHours = getContentFieldValue(
    content.businessHours,
    'Description',
  );

  return (
    <>
      <StyledNeedHelpModal name="needHelp" headerBackground="transparent">
        <div className="title">
          <SafeHtml>{title}</SafeHtml>
        </div>
        <StyledBusinessHours addTags={['img']} addAttr={['src']}>{businessHours}</StyledBusinessHours>
        <div>
          <StyledPhoneNumber addTags={['img']} addAttr={['src']}>{description}</StyledPhoneNumber>
        </div>
      </StyledNeedHelpModal>
      <StyledNeedHelpButton outline onClickAction="needHelp.openModal" data-testid="NeedHelp" style={hasOnClose && (isSmallScreen || testSmallScreen) ? ({ marginLeft: '32px', marginRight: '-32px' }) : ({})}>
        {t('needHelp')}
      </StyledNeedHelpButton>
    </>
  );
};

export default NeedHelp;
